import { DEFAULT_MAX_PAGE_SIZE, DEFAULT_PAGE } from 'hooks/usePaging'
import { stringify } from 'qs'
import { useEffect, useState } from 'react'
import axiosAdminPortal from 'utils/axiosAdminPortal'
import { defaultStringifyOption, getResponseData } from 'utils/commonUtils'

const CONSUMER_CUSTOMER_GROUP_CODE = 'consumer'

// Resolves the id of the "Consumer" customer group (the value the picklist
// `agentTypes` filter expects). Only fetches when `enabled` is true.
const useConsumerCustomerGroup = (enabled: boolean) => {
  const [consumerGroupID, setConsumerGroupID] = useState<string>()
  const [loading, setLoading] = useState(enabled)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setLoading(false)
      return
    }
    let isMounted = true
    const getConsumerGroup = async () => {
      try {
        setLoading(true)
        setError(false)
        const params = stringify(
          {
            ignorePerPage: true,
            page: DEFAULT_PAGE,
            perPage: DEFAULT_MAX_PAGE_SIZE,
          },
          defaultStringifyOption
        )
        const response = await axiosAdminPortal.get(
          `portal/api/v1/customer-groups?${params}`
        )
        const consumer = getResponseData<any[]>(response)?.find(
          (item) =>
            item?.code?.toLowerCase() === CONSUMER_CUSTOMER_GROUP_CODE &&
            item?.legacyID !== undefined
        )
        if (!isMounted) return
        if (consumer) {
          setConsumerGroupID(consumer.legacyID.toString())
        } else {
          setError(true)
        }
      } catch (e) {
        isMounted && setError(true)
      } finally {
        isMounted && setLoading(false)
      }
    }
    getConsumerGroup()
    return () => {
      isMounted = false
    }
  }, [enabled])

  return { consumerGroupID, loading, error }
}

export default useConsumerCustomerGroup
